/**
 * @generated SignedSource<<53d0b55eadb8c4ff452375a77961c4de>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ReactionButton_chat_socialThreadFragment$data = {
  readonly id: string;
  readonly reactions: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly deletedAt: ISO8601DateTimeString | null;
        readonly id: string;
        readonly senderId: string | null;
        readonly text: UnknownJSON;
      };
    }>;
  };
  readonly " $fragmentType": "ReactionButton_chat_socialThreadFragment";
};
export type ReactionButton_chat_socialThreadFragment$key = {
  readonly " $data"?: ReactionButton_chat_socialThreadFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ReactionButton_chat_socialThreadFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "reactions"
        ]
      }
    ]
  },
  "name": "ReactionButton_chat_socialThreadFragment",
  "selections": [
    (v0/*: any*/),
    {
      "alias": "reactions",
      "args": null,
      "concreteType": "ReactionsConnection",
      "kind": "LinkedField",
      "name": "__CommentsThread_reactions_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ReactionsEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Message",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "text",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "senderId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "deletedAt",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "SocialThread",
  "abstractKey": null
};
})();

(node as any).hash = "7f65ba95fe105bc43f4a218b3c8b8c12";

export default node;
